import { ResolveFn } from '@angular/router';
import { TeacherNotificationResponse } from '../../core/models/notification.model';
import { inject } from '@angular/core';
import { NotificationsService } from '../../core/services/notifications.service';

export const notificationsHistoryResolver: ResolveFn<TeacherNotificationResponse> = (
  route,
  state
) => {
  return inject(NotificationsService).getHistoryNotifications();
};
